import { connect } from 'react-redux';

import { IRootState } from 'src/redux/rootReducer';
import { Button, Text, View } from 'src/components/common';

export type OkModalData = {
  title?: string | React.ReactNode;
  message?: string;
  okText?: string;
  onOk?: (...arg: any[]) => void;
};
const OkModal: React.FC<Props> = ({ modalData }) => {
  const { title, message, okText, onOk = () => {} } = modalData;

  return (
    <View className={`ctn-modal__content`}>
      {title && <Text className="mb-4 ctn-modal__content__title">{title}</Text>}
      {message && <Text className="mb-5 ctn-modal__content__message">{message}</Text>}
      <View isRow justify="center">
        <Button onClick={onOk}>{okText || 'OK'}</Button>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IRootState) => ({
  modalData: state.modal.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OkModal);
